import Paths from '../utils/Paths';
import { LoaderFunction, redirect } from 'react-router-dom';

export const redirectProjects: LoaderFunction = () =>
  redirect(Paths.PROJECTS.INDEX);
